import { useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { authApi, errorMessage, unwrap } from "@/api/client";
import { Alert, Spinner } from "@/ui";

/** /verify-email?token=... подтверждает адрес; без токена показывает «проверьте почту». */
export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const email = (useLocation().state as { email?: string } | null)?.email;
  const [state, setState] = useState<"idle" | "loading" | "ok" | "error">(
    token ? "loading" : "idle",
  );
  const [message, setMessage] = useState<string>("");
  const [resent, setResent] = useState(false);

  useEffect(() => {
    if (!token) return;
    (async () => {
      try {
        const r = unwrap(await authApi.POST("/api/v1/auth/verify-email", { body: { token } }));
        setMessage(r.message);
        setState("ok");
      } catch (e) {
        setMessage(errorMessage(e));
        setState("error");
      }
    })();
  }, [token]);

  const resend = async () => {
    if (!email) return;
    await authApi.POST("/api/v1/auth/resend-verification", { body: { email } });
    setResent(true);
  };

  return (
    <div className="auth-card">
      <h1>Подтверждение email</h1>
      {state === "loading" && <Spinner />}
      {state === "idle" && (
        <>
          <p className="muted" style={{ margin: 0 }}>
            Мы отправили письмо{email ? ` на ${email}` : ""}. Перейдите по ссылке из письма, чтобы
            активировать аккаунт.
          </p>
          {email &&
            (resent ? (
              <Alert kind="success">Письмо отправлено ещё раз.</Alert>
            ) : (
              <button type="button" className="btn btn--secondary" onClick={resend}>
                Отправить письмо снова
              </button>
            ))}
        </>
      )}
      {state === "ok" && <Alert kind="success">{message}</Alert>}
      {state === "error" && <Alert kind="error">{message}</Alert>}
      <Link className="btn btn--block" to="/login">
        Войти
      </Link>
    </div>
  );
}
